enum SplitFeatureFlags {
  BRAVEHEART_FOUNDATIONS = 'braveheart_foundations',
  FIX_INCORRECT_BOOKS_CHECKBOX = 'fix_incorrect_books_checkbox_review_tool',
  SHOW_CONNECTION_STATE_IN_FLO = 'show_connection_state_in_flo',
  POTENTIAL_TRANSACTION_MATCHING = 'potential_transaction_matching',
  // This controls which Finch connections are actively syncing data and therefore which connections can be reset or deleted
  // A client may have a connected Finch account that is not actively syncing data
  FINCH_SYNC_ENABLED = 'finch_sync_control',
  // This controls which customers can see Finch on their Connection page and therefore which customers we can create connection requests for.
  FINCH_PAYROLL_AUTOMATION = 'finch_payroll_automation',
  MITO_FLO_STATUS = 'mito_flo_status',
  FLO_HORIZONTAL_SCROLL = 'flo_horizontal_scroll',
  DEPRECATE_SERVICE_INSTRUCTIONS_MFE = 'deprecate_service_instructions_mfe',
  DEPRECATE_BENCH_SERVICES_MFES = 'deprecate_bench_services_mfes',
  PLAID_OCR_BPA_UPLOAD_MIGRATED = 'plaid_ocr_bpa_upload_migrated',
  MESSAGE_FORMATTING_MILESTONE_1 = 'message_formatting_milestone_1',
  PERSONAL_BUSINESS_TRANSACTION_MANAGER = 'personal_business_transaction_manager',
  CONFIRM_CATEGORIZATION_TASKS = 'confirm_categorization_tasks',
  SMS_MESSAGE_FEED = 'sms_message_feed',
  AUTO_DOCUMENT_CLASSIFICATION = 'auto_document_classification',
  AUTO_DOCUMENT_CLASSIFICATION_AUTOFILL = 'auto_document_classification_autofill',
  ON_DEMAND_AI_STATEMENT_PARSING = 'on_demand_ai_statement_parsing',
  ASSIGN_CATEGORY_IMPROVEMENT = 'assign_category_improvement',
  INTERNAL_PLAID_OCR = 'internal_plaid_ocr',
  COMPANY_DETAILS_PAGE = 'company_details_page',
  // Only show the new YEF review status values in the drop-down when the backend has been turned on
  APPROVE_YEF_BACKEND = 'approve_yef_backend',
  // When ON, use new bench-backend GraphQL endpoints instead of AU REST endpoints for bench services
  USE_NEW_BENCH_SERVICES = 'bktools-use-new-bench-services',
}

export { SplitFeatureFlags };
